module.exports = __webpack_public_path__ + "static/img/iv_placeholder@2x.ebe7b1df.png";